var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 57,
    viewBox: "0 0 50 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2188 28.25C49.2188 14.9688 38.2812 4.03125 25 4.03125C11.6211 4.03125 0.78125 14.9688 0.78125 28.25C0.78125 41.6289 11.6211 52.4688 25 52.4688C38.2812 52.4688 49.2188 41.6289 49.2188 28.25ZM22.168 41.1406C21.582 41.7266 20.5078 41.7266 19.9219 41.1406L9.76562 30.9844C9.17969 30.3984 9.17969 29.3242 9.76562 28.7383L12.0117 26.5898C12.5977 25.9062 13.5742 25.9062 14.1602 26.5898L21.0938 33.4258L35.7422 18.7773C36.3281 18.0938 37.3047 18.0938 37.8906 18.7773L40.1367 20.9258C40.7227 21.5117 40.7227 22.5859 40.1367 23.1719L22.168 41.1406Z",
    fill: "#34A853"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.6f8e538c.svg";
export { ForwardRef as ReactComponent };